import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import ViewUtils from '../../ViewUtils';
import { AETAssessmentHeaderForm } from './AETAssessmentHeaderForm';
import AlertItem from "../../widgets/AlertItem";

const headCells = [
    { id: 'ProgrammeCode', numeric: false, disablePadding: true, label: 'Learning Area Code' },
    { id: "ProgrammeTitle", numeric: false, disablePadding: true, label: "Learning Area Description" },
    { id: "Status", numeric: false, disablePadding: true, label: "Competent" },
    { id: "AssessmentDate", numeric: false, disablePadding: true, label: "Assessment Date" },
    { id: "RPL", numeric: false, disablePadding: true, label: "RPL" },
    { id: "ModerationDate", numeric: false, disablePadding: true, label: "Certificate Date" }
]


const utils = new ViewUtils();
const toolbarRef = React.createRef();
const learnerRef = React.createRef();

class ViewAETAssessment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                AssessmentID: null
            },
            selectedModules: null,
            keyUpSwitch: false,
            messsageAlert: null,
            messageStyle: null,
            showTable: true,
            searchParameters: [{ Name: "AssessmentID", Value: this.props.location.state.AETID }],
            permissionItem: this.props.location.state.permissionItem,
            IsCreditBased:props.location.state.CreditBased
        }

        this.headCells = this.state.IsCreditBased ?
        [
            { id: 'ProgrammeCode', numeric: false, disablePadding: true, label: 'Learning Area Code' },
            { id: "ProgrammeTitle", numeric: false, disablePadding: true, label: "Learning Area Description" },
            { id: 'UnitStandardType', numeric: false, disablePadding: true, label: 'Learning Area Type' },
            { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
            { id: "Status", numeric: false, disablePadding: true, label: "Competent" },
            { id: "AssessmentDate", numeric: false, disablePadding: true, label: "Assessment Date" },
            { id: "RPL", numeric: false, disablePadding: true, label: "RPL" },
            { id: "ModerationDate", numeric: false, disablePadding: true, label: "Certificate Date" }
        ]
        :
        [
            { id: 'ProgrammeCode', numeric: false, disablePadding: true, label: 'Learning Area Code' },
            { id: "ProgrammeTitle", numeric: false, disablePadding: true, label: "Learning Area Description" },
            { id: "Status", numeric: false, disablePadding: true, label: "Competent" },
            { id: "AssessmentDate", numeric: false, disablePadding: true, label: "Assessment Date" },
            { id: "RPL", numeric: false, disablePadding: true, label: "RPL" },
            { id: "ModerationDate", numeric: false, disablePadding: true, label: "Certificate Date" }
        ];

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'cancel', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'update', label: '', tooltip: 'Update Assessments', icon: 'UpdateIcon', visible: this.state.permissionItem.Edit }
                    ]
                }
            ]
        };
    }
        
    


    handleToolbarButtonClick = (buttonId) => {
        if ("update" === buttonId) {
            this.updateModules();
        }
        else if ("cancel" === buttonId) {
            this.props.history.push({
                pathname: '/LearnerAETAssessments',
                state: {
                    learnerID: this.props.location.state.LearnerID,
                    learnerNames: this.props.location.state.learnerNames
                }
            });
        }
    }

    handleToolbarButtonClickClose = (buttonId) => {
        if ("cancel" === buttonId) {

        }
    }

    /*CheckCanUpdate() {
        let url = "api/sims/LearnerAETAssessment/CheckCanUpdateAssessment?ID=" + this.props.location.state.AETID;
        utils.invokeUrl(url, (response) => {
            if (response.Result !== "1") {
                toolbarRef.current.setButtonDisabled("update", true);
            }
            else {
                toolbarRef.current.setButtonDisabled("update", false);
            }

        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }*/

    successCallback = (response) => {
        this.setState({
            showTable: false,
            message: response.Message, messageStyle: response.MessageType
        }, () => {
            this.setState({ showTable: true, message: response.Message, messageStyle: response.MessageType })
        });
    }

    updateModules() {
        const ModuleIDs = this.state.selectedModules.map(e => e.Id);
        let data = {
            LearningAreaIDs: ModuleIDs,
            ...this.state.model
        }
        let input = JSON.stringify(data);
        utils.invokeUrl("api/sims/LearnerAETAssessment/UpdateLearnerAETAssessment", (response) => {
            this.successCallback(response);
        }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: input
        });
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedModules: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("update", selection.length === 0);
                }
            )
            //this.CheckCanUpdate();
        }
        else {
            this.setState({ selectedModules: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("update", selection.length === 0);
                }
            )
        }
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                this.setState({
                    model: newValues,
                    Message: ""
                });

                toolbarRef.current.setButtonDisabled("update", true);
                toolbarRef.current.setButtonDisabled("Cancel", true);
            }
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > Update AET Assessment > ${this.props.location.state.learnerNames}`}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                {this.state.showTable === true && (
                    <AETAssessmentHeaderForm
                        ref={learnerRef}
                        viewRef={this}
                        id={this.props.location.state.AETID}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}
                        controllerName={"LearnerAETAssessment"}
                        dataURL='api/sims/LearnerAETAssessment/GetLearnerAETAssessmentHeaderDetails' 
                        IsCreditBased={this.state.IsCreditBased}/>
                )}
                <td>
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                </td>

                <div>
                    {this.state.showTable === true && (
                        <EnhancedTable
                            multiSelect={true}
                            headCells={this.headCells}
                            dataUrl="api/sims/LearnerAETAssessment/getLearnerAETAssessmentDetails"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(ViewAETAssessment)
);